import HeroImageAnimated from './HeroImageAnimated'


export default HeroImageAnimated
